import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { ImageSavedPath } from '../Jugador/JugadorSystem';
import { Entrenador, EntrenadorJSON } from './Entrenador';

export class EntrenadorSystem {
  private readonly base = '/entrenadors';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getEntrenadorIdentifiedBy(id: string): Promise<Entrenador> {
    const data = await this.requestHandler.get<EntrenadorJSON>(`${this.base}/${id}`);
    return Entrenador.fromJSON(data);
  }

  async getList(): Promise<Entrenador[]> {
    const data = await this.requestHandler.get<EntrenadorJSON[]>(`${this.base}`);
    return data.map((entity) => Entrenador.fromJSON(entity));
  }

  async getListForDropdown(): Promise<Entrenador[]> {
    const data = await this.requestHandler.get<EntrenadorJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => Entrenador.fromJSON(entity));
  }

  async save(entity: Entrenador) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<EntrenadorJSON, EntrenadorJSON>(this.base, data);
    return Entrenador.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }

  getUrlForImage(image: string) {
    return this.requestHandler.requestUrl(`/uploads/images/entrenador/${image}`);
  }

  async getEntrenadoresByClubList(clubIdList: string[]): Promise<Entrenador[]> {
    const url = `${this.base}/entrenadores-by-club-list`;
    const data = await this.requestHandler.post<EntrenadorJSON[]>(url, { clubes: clubIdList });
    return data.map((entity) => Entrenador.fromJSON(entity));
  }
}
